<template>
  <div>
    <section class="hero-image-1">
        <div class="flex-column flex-justify-center section-container">
            <img class="hero-logo" src="../assets/img/HW_Logo_White.png"/>
            <div class="flex-row flex-justify-center hero-button-container">
                <a href="https://discord.com/channels/1175578840614051960/1289270522286313482"                     
                    target="_blank"
                    rel="noopener noreferrer">
                    <button class="btn btn-primary save-btn btn-styled">
                        Download now
                    </button>
                </a>
                <a href="https://youtu.be/_X9nzDNwOtQ?si=379cMiTGajY1ut3x"                     
                    target="_blank"
                    rel="noopener noreferrer">
                    <button class="btn btn-primary save-btn btn-styled">
                        Trailer
                    </button>
                </a>
            </div>

        </div>
    </section>
    <svg-icon-container  
        class="section-divider"
        :hidden="false"
        icon="websiteDivider">
    </svg-icon-container>
    <section id="about" class="flex-column">
        <div class="flex-row section-container" >
            <div class="flex-column section-info ">
                <h2 class="section-title">
                    Welcome to Hermertia
                </h2>
                <p>
                    Heroes from across <a href="http://hermertia.com">Hermertia’s 1000 years of history</a> find themselves in new lands, vast floating islands rich with resources. There are many paths to thrive: expand your economy, build impenetrable defenses, mass vast armies, or play your enemies against each other. Because eventually those resources run dry.
                </p>
                <p >
                    Hermertia Wars is an Action Real Time Strategy (RTS), combining thrilling yet intuitive combat with building, economy, and NPC management. It is an Action game because you control a single hero. Think of classic arcade fighters like Smash Bros. But it is an RTS because you consume resources to build settlements, resource camps, and barracks, and recruit soldiers to help you secure success for your people. 
                </p>
            </div>
            <div class="flex-column flex-column-2 svg-container image-margin-top">
                <img class="" src="../assets/img/bone_king_celestine.jpg"/>
            </div>
        </div>
    </section>
    <svg-icon-container  
        class="section-divider"
        :hidden="false"
        icon="websiteDivider">
    </svg-icon-container>
    <section class="">
        <div class="flex-row section-container">
            <div class="flex-column flex-item-center flex-grow card-wrapper">
                <div class="flex flex-column">
                    <div class="flex flex-row btn-container flex-justify-center">
                        <template v-for="feature in features">
                            <button 
                                class="btn btn-outline-default"
                                :class="(activeFeature == feature) ? 'active' : ''"
                                @click="updateActiveFeature(feature)">
                                    {{ feature }}
                            </button>
                        </template>
                    </div>
                </div>
                <div class="flex flex-row section-container">
                        <template v-if="activeFeature == 'Heroes'">
                            <div class="flex-column flex-column-2 svg-container">
                                <img class="" src="../assets/img/yuick_and_sameria.jpg"/>
                            </div>
                            <div class="flex-column section-info">
                                <h2 class="section-title">
                                    Heroes
                                </h2>
                                <p>
                                    8 heroes were picked from early Hermertina history. Each were influential figures in their day, and each shaped the geopolitics of an Empire.  
                                </p>
                                <ul>
                                    <li>
                                        <span class="font-green">Governor Amador of West Demurgia </span>- Cunning yet cut-throat diplomat
                                    </li>
                                    <li>
                                        <span class="font-blue">Kyn of Valtoros </span> - King of the people of the monsters
                                    </li>
                                    <li>
                                        <span class="font-orange" >The Bone King of the Hotonotochi Uprising </span> - The defier of vassalization
                                    </li>
                                    <li>
                                        <span class="font-cyan" >Celestine</span> - She who guides the cycles of magic
                                    </li>
                                    <li>
                                        <span class="font-magenta" >Yuick of Kane </span> - Illustrious architect of the fabled games
                                    </li>
                                    <li>
                                        <span class="font-grey" >Sameria of the Ilmenite Coast </span> - Grand artificer and master of rubystone
                                    </li>
                                    <li>
                                        <span class="font-red" >Atryl of Mista Rihw - </span> The shadow of Old Hermertia
                                    </li>
                                    <li>
                                        <span class="font-yellow">Aurennis of Casadia  </span> - Blade of the desert dragon
                                    </li>
                                </ul>
                                <p>
                                    Each with their own unique combat style heavily inspired by classic arcade fighters. Smash, dash, combo and ranged attacks help you defend your settlers or knock your opponents off the lands. 
                                </p>
                            </div>
                        </template>
                        <template v-if="activeFeature == 'Economy'">
                            <div class="flex-column flex-column-2 svg-container">
                                <img class="" src="../assets/img/buildings_example.jpg"/>
                            </div>
                            <div class="flex-column section-info">
                                <h2 class="section-title">
                                    Economy
                                </h2>
                                <p>
                                    Each hero starts with a settlement which recruits villagers. Villagers can be assigned to Resource Camps or Barracks. Manage the gathering of food, wood, stone, and other resources to help build your economy, unlock new research tech, and expand your presence on the map. 
                                </p>
                                <p>
                                    Maps are randomly generated, so no two matches are the same. Choose between temperate, jungle, arid, or tundra map themes which each alter the match ever so slightly.
                                </p>
                            </div>
                        </template>
                        <template v-if="activeFeature == 'Lore'">
                            <div class="flex-column flex-column-2 svg-container">
                                <img class="" src="../assets/img/atryl_and_aurennis.jpeg"/>
                            </div>
                            <div class="flex-column section-info">
                                <h2 class="section-title">
                                    Lore
                                </h2>
                                <p>
                                    Over a decade ago a Minecraft community was founded built around "lore-playing". Newcomers to the Mercurian Empire were given lands they could vye for if they explored, built, engaged in diplomacy and more. 1 year in real life is about 60 years in our world of Hermertia. So, since that community was founded, over 1000 years of history has passed. From conflict and intrigue, to peace and trade, there is no world like Hermertia. We have a rich history shaped by the still thriving Hermertian community. Join us in expanding this world! 
                                </p>
                            </div>
                        </template>
                           <template v-if="activeFeature == 'Worker-Owned'">
                            <div class="flex-column flex-column-2 svg-container">
                                <img class="image-smaller" src="../assets/img/hermertiastudios_cooperative_logo.png" />
                            </div>
                            <div class="flex-column section-info" >
                                <h2 class="section-title">
                                    Worker-Owned Cooperative
                                </h2>
                                <p>
                                    We believe a workers-cooperative is a good model for a game studio built around community-based projects and passions. We are incorporated in Canadian Cooperative Law and anyone who formally works on the project and whose work is included in our commercial launch, will be an equal owner of our cooperative and will share the profit of that commercial project. This has brought together a team of programmers, a composer, a creative design lead, a web/devops architect, a community manager, a 3d modeller, an animator, and more. Not to mention each author of the 8 heroes is an owner too, as we could not build this world without their incredible characters and lore. 
                                </p>
                            </div>
                        </template>
                </div>
            </div>
        </div>
    </section>
    <svg-icon-container  
        class="section-divider"
        :hidden="false"
        icon="websiteDivider">
    </svg-icon-container>
    <section class="">
        <div class="flex-row section-container">
            <div class="flex-column flex-item-center flex-grow card-wrapper">
                <h2 class="section-title">Latest News</h2>
                <div class="flex-row flex-row-gap flex-justify-center card-container">
                    <template v-for="item in newsArticles">
                        <router-link class="news-link" :to="{path: 'news-articles/' + item.id}">
                            <card class="landing-cards news-card neutral no-padding">
                                <template #image>
                                    <img :src="item.coverImg.url"/>
                                </template>
                                <div>
                                    <h3>
                                        {{ item.title }}
                                    </h3>
                                    <p>
                                        {{item.thumbnailDescription}}
                                    </p>
                                </div>
                                <template #footer>
                                    <p class="card-text">
                                        Read more
                                    </p>
                                </template>
                            </card>
                        </router-link>      
                    </template>
                </div>
            </div>
        </div>
    </section>
    <svg-icon-container  
        class="section-divider"
        :hidden="false"
        icon="websiteDivider">
    </svg-icon-container>
    <section class="flex-row">
        <div class="flex-column section-container">
            <h2 class="section-title">Gallery</h2>
            <div class="flex flex-column">
                <div class="flex flex-row btn-container flex-justify-center">
                    <button 
                        class="btn btn-outline-default"
                        :class="(galleryCategory == 'Images') ? 'active' : ''"
                        @click="galleryCategory = 'Images'">
                            Images
                    </button>
                    <button 
                        class="btn btn-outline-default"
                        :class="(galleryCategory == 'Videos') ? 'active' : ''"
                        @click="galleryCategory = 'Videos'">
                            Videos
                    </button>
                </div>
                <div v-if="galleryCategory == 'Images'" class="flex flex-row btn-container flex-justify-center">
                    <template v-for="filter in galleryFilters">
                        <button 
                            class="btn btn-outline-default"
                            :class="(activeGalFilter == filter) ? 'active' : ''"
                            @click="updateActiveGalFilter(filter)">
                                {{ filter }}
                        </button>
                    </template>
                </div>
            </div>
            <div v-if="galleryCategory == 'Videos'" class="flex-row">
                <div class="flex-column flex-item-center video-gallery">
                    <div class="flex-row flex-1 width-100 flex-justify-center video-gallery">
                        <template v-for="channelVideo in youTubeVids">
                            <div v-if="channelVideo.id.videoId" class="video-container">
                                <div>
                                    <iframe :src="'https://www.youtube.com/embed/' + channelVideo.id.videoId" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>
                            </div>
                        </template>
                    </div>
                    <a href="https://www.youtube.com/channel/UCL7im8jz9wEMLyHoZiPoNjQ"                     
                        target="_blank"
                        rel="noopener noreferrer">
                        <button class="btn btn-outline-default btn-styled">
                            Our YouTube Channel
                        </button>
                    </a>
                </div>
            </div>
            <div v-else class="flex-row flex-1 flex-justify-center image-gallery">
                <template v-for="imgInfo in filteredGallery">
                    <img :src="imgInfo.thumbnail" @click="openGallery(imgInfo.original)" :disabled="toggleLightBox">
                </template>
            </div>
        </div>
    </section>
    <svg-icon-container  
        class="section-divider"
        :hidden="false"
        icon="websiteDivider">
    </svg-icon-container>
    <section class="">
        <div class="flex-row section-container">
            <div class="community flex-column flex-1">
                <h2 class="section-title">Community</h2>
                <p>Hermertia Wars knows that our community is extremely important. Join / follow us on the community items below.</p>
                <div class="community flex-left">
                    <simple-input
                        :inputs="inputs"
                        :checkValidity="validateInputs"
                        :checkSelector="'.fieldGroupContainer'"
                        @valid="passFailInputs">
                    </simple-input>
                </div>
                <div class="community flex-row flex-left">
                    <button v-if="transactionFeedback.code != 403" class="btn btn-primary save-btn" @click.prevent="checkInputs()">
                        Sign Up
                    </button>
                    <button v-if="transactionFeedback.code == 403"
                        class="btn btn-success"
                        @click.prevent="resendVerificationEmail">
                        Resend Verification
                    </button>
                    <div class="form-group margin-bottom-0 width-100">
                        <div v-show="this.transactionFeedback['message'] != ''" 
                            class="alert margin-bottom-0"
                            :class="alertLevel" 
                            role="alert">
                                {{this.transactionFeedback['message']}}
                        </div>
                    </div>
                    <span class="width-100">By clicking "sign up" you are agreeing to our <router-link :to="{name: 'Privacy'}">Privacy Agreement</router-link></span>
                </div>
            </div>
            <div class="flex-column flex-column-2 flex-item-end svg-container">
                <img class="image-smallest image-margin-right" src="../assets/img/0_1_7_screen.jpg"/>
            </div>
        </div>
    </section>
    <FsLightbox
        ref="lightbox"
        :toggler="toggleLightBox"
        :sources="lightBoxSources">
    </FsLightbox>
  </div>
</template>
<script>
import { SvgIconContainer } from "@/components";
import FsLightbox from "fslightbox-vue/v3";
import SimpleInput from '../components/SimpleInput.vue';
import inputValidationParent from '../utilities/inputValidationParent';
import strapiMixins from "../utilities/strapiMixins";
import galleryMixins from "../utilities/galleryMixins";
import generalServices from '../services/GeneralServices';
import strapiServices from '../services/StrapiServices';

export default {
  components: {
    'svg-icon-container': SvgIconContainer,
    FsLightbox,
    SimpleInput
  },
  mixins: [inputValidationParent, galleryMixins, strapiMixins],
  data() {
    return {
      activeFeature: "Heroes",
      activeGalFilter: "All",
      galleryCategory: 'Images',
      toggleLightBox: false,
      features: [
        "Heroes", 
        "Economy",
        "Lore",
        "Worker-Owned"
      ],
      galleryFilters: [
        "All",  
        "Community",
        "Concept Art",
        "Gameplay",
      ],
      formInfo: {
        email: ""
      },
      inputs: [
        {type: "email", category: "email", required: true},
      ],
      transactionFeedback: {
        'message': "",
        'code': ""
      },
      youTubeVids: [],
    };
  },
  created () {
    
  },
  computed: {
    alertLevel() {
        if (this.transactionFeedback['code'] == 0) {
            return "alert-loading";
        } else if (/^(2)/.test(this.transactionFeedback['code'])) {
            return "alert-success";
        } else {
            return "alert-danger";
        }
    },
    filteredGallery() {
        let tempGal = this.imageGallery;
        if (this.activeGalFilter == "All") {
            return tempGal;
        } else {
            tempGal = tempGal.filter((item) => {
                return item.name.includes("+" + this.activeGalFilter)
            })
        }

        return tempGal;
    }
  },
  mounted() {
    this.getRecentNews();
    this.getMediaImages();
    this.getYouTubeVids();
  },
  filters: {
    
  },
  methods: {
    updateActiveFeature(value) {
        this.activeFeature = value;
    },
    updateActiveGalFilter(value) {
        this.activeGalFilter = value;
    },
    async getYouTubeVids() {
        try {
            let response = await generalServices.GET_DATA("https://www.googleapis.com/youtube/v3/search?key=AIzaSyD0UfKWgvTfaDK5bq-kgaXa2c48ZDtVZh0&channelId=UCL7im8jz9wEMLyHoZiPoNjQ&order=date&maxResults=15");
            this.youTubeVids = response.data.items;
            console.log(this.youTubeVids);
        } catch (err) {
            console.log(err);
        }
    },
    async postModal(formInfo) {
        try {
            this.loadingMessage = "Sending you an email, please wait!";
            this.transactionFeedback['message'] = this.loadingMessage;
            this.transactionFeedback['code'] = 0;
            let response = await generalServices.POST_DATA("register/", formInfo);
            this.message = "";
            this.transactionFeedback['message'] = response.data;
            this.transactionFeedback['code'] = response.status;
        } catch (err) {
            console.log(err);
            this.message = "";
            this.transactionFeedback['message'] = err.response.data;
            this.transactionFeedback['code'] = err.response.status;
        }
    },
    async resendVerificationEmail() {
        this.message = "Resending verification email, please wait!";
        try {
            let response = await generalServices.POST_DATA("resendVerification/",
                {
                    'email': this.inputValues['email']
                }
            );
            this.message = "";
            this.transactionFeedback['message'] = response.data;
            this.transactionFeedback['code'] = response.status;
        } catch (err) {
            this.message = "";
            this.transactionFeedback['message'] = err.response.data;
            this.transactionFeedback['code'] = err.response.status;
        }
    },
    async getRecentNews() {
        try {
            let response = await strapiServices.GET_STRAPI("news-articles/");
            let articles = this.getArticles(response);
            let numArticles = articles.length;

            if (numArticles > 3) {
                let numToSlice = -numArticles + 3;
                if (numToSlice < 0) {
                    articles.splice(numToSlice)
                }
            }

            this.newsArticles = articles;
        } catch (err) {
            console.log(err);
        }
    },
  }
};</script>
<style lang="scss">
</style>
